/* import __COLOCATED_TEMPLATE__ from './location-step.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class RequestStepsLocationStep extends Component {}
